import React from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer'

const sections = [
  {
    title: 'Acceptance of Terms',
    body: 'By accessing or using this website, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our site.'
  },
  {
    title: 'Use of Website',
    body: 'This website is provided for informational purposes about Zeiger Software Solutions and our services. You may not use this site for any unlawful purpose or in any way that could damage, disable, or impair the site.'
  },
  {
    title: 'Services',
    body: 'Information on this site describes the types of services we offer. Engaging us for services is subject to a separate written agreement. Nothing on this site constitutes an offer or guarantee of services.'
  },
  {
    title: 'Intellectual Property',
    body: 'All content on this website, including text, graphics, logos, and code, is the property of Zeiger Software Solutions, LLC and is protected by applicable intellectual property laws. You may not reproduce or redistribute any content without our written permission.'
  },
  {
    title: 'Limitation of Liability',
    body: 'Zeiger Software Solutions, LLC is not liable for any direct, indirect, incidental, or consequential damages arising from your use of this website or reliance on any information presented here. The website is provided as-is without warranties of any kind.'
  },
  {
    title: 'Changes to Terms',
    body: 'We reserve the right to update these terms at any time. Continued use of the site after changes are posted constitutes your acceptance of the updated terms.'
  },
  {
    title: 'Contact Us',
    body: 'If you have any questions about these Terms of Service, please contact us at hello@zeigersoftware.com.'
  }
]

const TermsOfService: React.FC = () => {
  return (
    <div className='flex flex-col min-h-screen bg-bg'>
      <Nav />
      <main className='flex-1 max-w-3xl mx-auto w-full px-4 md:px-8 py-16 md:py-24'>
        {/* <p className='text-[12px] font-bold tracking-[2px] uppercase text-pop mb-3 font-bd'>
          Legal
        </p> */}
        <h1 className='font-hd font-extrabold text-[32px] md:text-[42px] tracking-[-1px] text-ink mb-4'>
          Terms of Service
        </h1>
        <p className='text-[14px] text-ink3 font-bd mb-12'>
          Last updated: April 23, 2026
        </p>

        <p className='text-[15px] text-ink2 font-bd leading-[1.75] mb-12'>
          Please read these Terms of Service carefully before using the Zeiger Software Solutions website.
          These terms govern your access to and use of our site and services.
        </p>

        <div className='flex flex-col gap-10'>
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className='font-hd font-bold text-[18px] text-ink mb-3'>{s.title}</h2>
              <p className='text-[15px] text-ink2 font-bd leading-[1.75]'>{s.body}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default TermsOfService
